import React from 'react'

const Members = () => {
  return <h1>Integrantes</h1>
}

export default Members